module.exports = __webpack_public_path__ + "static/media/awslogo.47004c68.png";